export default "__VITE_ASSET__Du8Sff8D__"